import axios from "axios";
import { MessageBox } from "element-ui";
import store from "@/store";
import { getToken, getUserName } from "@/utils/auth";
import { getSysToken } from "@/utils/h5auth";
import router from "@/router";
import { logout, isWX } from "@/utils/nativebridge";

// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // api 的 base_url
  timeout: 100000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  if (getToken()) {
    config.headers["Authentication"] = getToken();
  }
  if (getSysToken()) {
    config.headers["Authentication"] = getSysToken();
  }

  // 访问日志处理
  accessLog(config);
  return config;
}, function (error) {
  // Do something with request error
  console.log("request error: ", error); // for debug
  Promise.reject(error);
});

// 访问日志处理
function accessLog(config) {
  // 账号
  var username = getUserName();
  // 记录账号
  if (username) {
    if (config.url.indexOf("?") === -1) {
      config.url += "?logid=".concat(username);
    } else {
      config.url += "&logid=".concat(username);
    }
  }
}

// 登录状态检查
function checkLogin(response) {
  var res = response.data;

  // 1:非法的token; 2:其他客户端登录了;  3:Token 过期了;
  if (res.error == '1' || res.error == '2' || res.error == '3') {
    if (router.history.current.path.indexOf("/h5/") !== -1) {
      if (isWX()) {
        router.push("/h5/syslogin");
      } else {
        logout();
      }
    } else {
      MessageBox.confirm("你已被登出，可以取消继续留在该页面，或者重新登录", "确定登出", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        router.push("/login?redirect=".concat(router.fullPath));
        store.dispatch("user/logout").then(function () {
          location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
      });
    }
  }
  return res;
}

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (res.error) {
    if (res.error == '-1') {
      return res;
    } else {
      return checkLogin(response);
    }
  } else {
    return Promise.reject(res);
  }
}, function (error) {
  console.log("response error: " + error); // for debug
  return Promise.reject(error);
});
export default service;